/** @jsx jsx */
import { jsx, } from '@emotion/core';
import styled from '@emotion/styled';
import { ReactComponent as KBBLogoSeal, } from '../../../images/KBBLogoSeal.svg';
import { ReactComponent as KBBLogoType, } from '../../../images/KBBLogoType.svg';

const StyledHeader = styled.div`
  background: #fff;
  border-radius: 4px 4px 0 0;
  width: 100%;
  height: 48px;
  ${({ theme, }: any) => `
    background-color: ${theme.global.color};
  `}
`;

const HeaderInfo = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  justify-content: no;
`;

const StyledSealSvg = styled.svg`
  height: 65px;
  width: 48px;
  margin-left: 12px;
`;

const StyledTypeSvg = styled.svg`
  height: 29px;
  width: 158px;
  margin-top: 8px;
  margin-left: 8px;
  margin-bottom: 11px;
`;

const Header = (): JSX.Element => (
  <StyledHeader>
    <HeaderInfo>
      <StyledSealSvg>
        <KBBLogoSeal />
      </StyledSealSvg>
      <StyledTypeSvg>
        <KBBLogoType />
      </StyledTypeSvg>
    </HeaderInfo>
  </StyledHeader>
);

export default Header;
